import { defineComponent as i, computed as r } from "vue";
import u from "./td-longtail-vue-components80.js";
import p from "./td-longtail-vue-components3.js";
const m = /* @__PURE__ */ i({
  __name: "dropdown-item",
  props: {
    url: { default: void 0 },
    selected: { type: Boolean },
    ariaLabel: { default: void 0 },
    label: { default: void 0 },
    value: { default: void 0 },
    count: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    breakText: { type: Boolean }
  },
  emits: ["click"],
  setup(a, { expose: d, emit: o }) {
    const e = a, t = r(() => !!e.url && !e.disabled), l = (n) => {
      n.preventDefault(), !e.disabled && o("click", e.value);
    };
    return d({
      hasLink: t
    }), { __sfc: !0, props: e, emit: o, hasLink: t, onClick: l, DropdownItemContent: u, LinkButton: p };
  }
});
export {
  m as default
};
